module.exports = __webpack_public_path__ + "img/new4.71434ef7.png";